import axios from 'axios';
import { toaster } from '../components/common/Toaster';
import { environment } from '../environments/environment';
import { checkIfServerError } from './AuthActionsAPI';
import { PortalApiToken } from '../services/api/api-token';
 /**
 * An authenticated user wants to logout.
 * Upon completion,
 * the user will be logged out of the application.
 *
 * @returns Resolve if successful, otherwise reject with an error message.
*/
export const logoutUser = () => {
    const baseURL = environment.baseURL;
    const id = window.localStorage.getItem('userId');
    const authorizationToken = 'Bearer ' + window.localStorage.getItem('accessToken');
    const params = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Authorization": authorizationToken
        }
    }
     axios.delete(`${baseURL}/security/logoff/${id}`, params)
        .then(() => {
        // Success
        window.localStorage.removeItem('userDetails');
        window.localStorage.removeItem('userId');
        window.localStorage.removeItem('currentUser');
        PortalApiToken.resetTokenData();
    })
    .catch((error) => {
        // Error
        PortalApiToken.resetTokenData();
        if(checkIfServerError(error)){
            toaster(`${error.message}`)
        }
        if (error && Object.prototype.hasOwnProperty.call(error, 'message')) {
            throw new Error(error.message);
        }
        else {
            throw new Error('Something went wrong! Please contact administrator.');
        }
    });
    return;
}